<template>
  <div class="w-100">
    <div :id="dropzoneId" class="dropzone" :style="{backgroundImage: image ? `url('${image}')` : null}">
      <div v-if="linkDownload" style="margin: 0; padding: 0; position: relative;">
        <a :href="linkDownload" target="_blank">
          <Icon
              icon="mdi:download-box"
              class="text-primary"
              style="font-size: 24px;position: absolute;top: 22px;right: 8px;cursor: context-menu"
          />
        </a>
      </div>
      <div v-if="image" style="margin: 0;padding: 0;position: relative">
        <Icon
            icon="carbon:close-filled" class="text-primary"
            style="font-size: 20px;position: absolute;top: 0;right: 10px;cursor: context-menu"
            @click="remove"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Dropzone from 'dropzone'
import 'dropzone/dist/dropzone.css'
import pdfIcon from "../assets/img/pdf-icon.webp";

const props = defineProps({
  modelValue: {type: String, default: () => ''},
  accept: {type: String, default: () => 'image/*'}
})

const emit = defineEmits(['update:modelValue'])
const image = ref(null)
const linkDownload = ref(null)
const dropzoneId = useId()
let dropzoneInstance = null

const base64Files = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    linkDownload.value = newValue
    image.value = newValue.endsWith('pdf') ? pdfIcon : newValue
  } else {
    image.value = null
    linkDownload.value = null
  }
}, { immediate: false })

onMounted(() => {
  if (props.modelValue) {
    linkDownload.value = props.modelValue
    image.value = props.modelValue.endsWith('pdf') ? pdfIcon : props.modelValue
  }
  if (Dropzone.instances.some(instance => instance.element.id === dropzoneId)) {
    console.warn(`Dropzone is already attached #${dropzoneId}`)
    return
  }

  try {
    dropzoneInstance = new Dropzone(`#${dropzoneId}`, {
      url: '#',
      acceptedFiles: props.accept,
      dictDefaultMessage: 'Arraste o arquivo aqui ou clique para fazer upload',
      addedfile: (file) => {
        const reader = new FileReader()
        reader.onload = () => {
          base64Files.value = reader.result
          image.value = reader.result

          if (file.type === 'application/pdf') {
            image.value = pdfIcon
          }
        }
        reader.onerror = (error) => {
          console.error('upload error:', error)
        }
        reader.readAsDataURL(file)
      },

      error: (file, errorMessage) => {
        console.error('upload error:', errorMessage)
      }
    })
  } catch (error) {
    console.error('Erro ao inicializar o Dropzone:', error)
  }
})

onUnmounted(() => {
  if (dropzoneInstance) {
    dropzoneInstance.destroy()
    dropzoneInstance = null
  }
})

const remove = () => {
  base64Files.value = null
  image.value = null
}
</script>

<style>
.dropzone {
  border: 2px dashed #ddd;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.dropzone .dz-message {
  font-size: 16px;
  color: #333;
  margin: 10px 0 0 0;
}

</style>
